import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import PageMetaContext from '../../context/page-meta-context';

import { THEME_GREY } from '../../theme/theme'

import { getDataLayer } from '../../utils/gtm'
import { logData } from '../../services/gtm'

import SectionContainer from '../section-container'

import { Container, Location, Summary, Name, Address, Communication, Contacts, ContactsInner, Contact, ContactRole, ContactName, ContactCommunication } from './contact-locations.styles'


const ContactLocations = ({items}) => {
	const meta = useContext(PageMetaContext);

	const sorted = items.concat().sort((a,b) => {
		
		if(a.contacts.length > b.contacts.length) {
			return -1;
		}
		if(a.contacts.length < b.contacts.length) {
			return 1;
		}

		var nameA = a.name.toLowerCase();
		var nameB = b.name.toLowerCase();

		if(nameA < nameB) {
			return -1;
		}
		if(nameA > nameB) {
			return 1;
		}

		return 0;
	})

	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer condenseTop>
				{sorted.map((item,locationIndex) => 
					<Location key={locationIndex}>
						<Summary>
							{item.name && <Name>{item.name}</Name>}
							{item.address && <Address><RichContent render={item.address} /></Address>}
							{item.email && <Communication href={`mailto:${item.email}`} onClick={(e) => logData(getDataLayer({block:"contact-locations",meta},`email-${item.name}`))}>{item.email}</Communication>}
							{item.phone && <Communication href={`tel:${item.phone}`} onClick={(e) => logData(getDataLayer({block:"contact-locations",meta},`phone-${item.name}`))}>{item.phone}</Communication>}
						</Summary>
						<Contacts>
							<ContactsInner>
								{item.contacts.map((contact,contactIndex) => 
									<Contact key={contactIndex}>
										{contact.contact_role && <ContactRole>{contact.contact_role}</ContactRole>}
										{contact.contact_name && <ContactName>{contact.contact_name}</ContactName>}
										{contact.contact_email && <ContactCommunication href={`mailto:${contact.contact_email}`} onClick={(e) => logData(getDataLayer({block:"contact-locations",meta},`email-${contact.contact_name}`))}>{contact.contact_email}</ContactCommunication>}
										{contact.contact_phone && <ContactCommunication href={`tel:${contact.contact_phone}`} onClick={(e) => logData(getDataLayer({block:"contact-locations",meta},`phone-${contact.contact_name}`))}>{contact.contact_phone}</ContactCommunication>}
									</Contact>
								)}
							</ContactsInner>
						</Contacts>
					</Location>
				)}
			</SectionContainer>
		</ThemeProvider>
	)
}

export default ContactLocations;